/**
 * The scheduling service: availability, open shifts, shift swaps, giveaways,
 * schedule acknowledgements, and notification settings. Read from
 * VITE_SCHEDULING_SERVICE when a build is made; absent or anything other than
 * "true" leaves them out of the interface. It is a function, not a constant,
 * so a test can set the variable and see either state.
 */
export function schedulingServiceEnabled(): boolean {
  return import.meta.env.VITE_SCHEDULING_SERVICE === 'true'
}
